<template>
  <v-card
    class="ma-3 pa-3"
    :class="{ 'elevation-0': $vuetify.breakpoint.smAndDown }"
  >
    <v-card-body>
      <v-row>
        <v-col cols="12" class="text-center">
          <v-avatar size="120" tile>
            <v-icon
              v-if="picEmpPath.type === 'icon'"
              v-text="picEmpPath.src"
              size="180"
            />
            <v-img
              v-if="picEmpPath.type === 'img'"
              :src="picEmpPath.src"
              contain
            />
          </v-avatar>
        </v-col>

        <v-col cols="12" class="body-2 text-center">
          <div v-text="emailCMU"></div>
          <div v-text="name"></div>
        </v-col>

        <v-col cols="12" class="body-2 text-center">
          <div v-text="position"></div>
        </v-col>
      </v-row>
    </v-card-body>
  </v-card>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    picEmpPath() {
      let res = { type: 'icon', src: 'Na' }
      const picEmpPath = this.info.picEmpPath
      if (picEmpPath) {
        res = {
          type: 'img',
          src: picEmpPath
        }
      } else {
        res = { type: 'icon', src: 'mdi-account' }
      }

      return res
    },

    name() {
      const firstNameTha = this.info.firstNameTha || ''
      const middleNameTha = this.info.middleNameTha || ''
      const lastNameTha = this.info.lastNameTha || ''

      return firstNameTha + ' ' + middleNameTha + ' ' + lastNameTha
    },

    emailCMU() {
      return this.info.emailCMU ? this.info.emailCMU : ''
    },

    position() {
      let res = 'ตำแหน่ง: '
      const positionName = this.info.positionNameTha
      if (positionName) res += positionName
      return res
    }
  }
}
</script>

<style lang="scss" scoped></style>
